import {
  type PerspectivePortfolio,
  type SetComplexImmerStateAction,
} from '@/lib/types';
import dummyFunction from '@/lib/utils/dummyFunction';
import { createContext } from 'react';

const PerspectivePortfolioContext = createContext<
  [PerspectivePortfolio, SetComplexImmerStateAction<PerspectivePortfolio>]
>([{}, dummyFunction]);

export default PerspectivePortfolioContext;
